import React from 'react';
import styles from './LeftColumnWrapper.css';

class LeftColumnWrapper extends React.Component {
  render() {
    const { openRightColumn, isWiderLeft } = this.props;
    const classSlider = openRightColumn
      ? isWiderLeft
        ? 'col-md-7 col-lg-7 visible-md visible-lg visible-sm'
        : 'col-md-6 col-lg-6 visible-md visible-lg visible-sm'
      : 'col-md-12 col-lg-12';

    return (
      <div id="mk-col-left" className={`${styles.wrapper} ${classSlider}`}>
        {this.props.children}
      </div>
    );
  }
}

export default LeftColumnWrapper;
